import { render, staticRenderFns } from "./Minesweeper.container.vue?vue&type=template&id=5bd15870&scoped=true&"
import script from "./Minesweeper.container.vue?vue&type=script&lang=js&"
export * from "./Minesweeper.container.vue?vue&type=script&lang=js&"
import style0 from "./Minesweeper.container.vue?vue&type=style&index=0&id=5bd15870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd15870",
  null
  
)

export default component.exports